/**
 * CompuMe custom.js
 * Cart bug fix + Storage brand filter strip
 */

/* ─── CART FIX ─────────────────────────────────────────────────────────────────
 * Patches Shopify.addItem to:
 * 1. Use fetch() + JSON instead of jQuery $.ajax (avoids jQuery dataType issues)
 * 2. Strip GID prefix if present (gid://shopify/ProductVariant/123 → 123)
 * 3. Normalize legacy jQuery/DOM arguments before using DOM APIs
 * 4. Carry product properties and selling-plan data from the source form
 * 5. Read the actual Shopify error description and show it
 * ────────────────────────────────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {

  if (typeof Shopify === 'undefined') return;

  function toDomElement(ref) {
    if (!ref) return null;
    if (ref.nodeType === 1) return ref;
    if (ref.jquery && ref[0] && ref[0].nodeType === 1) return ref[0];
    if (typeof ref.length === 'number' && ref[0] && ref[0].nodeType === 1) return ref[0];
    return null;
  }

  Shopify.addItem = function (variant_id, quantity, $target, callback, input) {
    var targetEl = toDomElement($target);
    var inputEl = toDomElement(input);

    // Strip GID prefix if accidentally passed
    var numericId = String(variant_id).replace(/^gid:\/\/shopify\/ProductVariant\//, '');
    quantity = parseInt(quantity, 10) || 1;

    var formData = new FormData();
    formData.append('id', numericId);
    formData.append('quantity', quantity);

    // Carry over product properties and selling-plan data from the source form.
    var form = targetEl && targetEl.closest ? targetEl.closest('form') : null;
    if (form) {
      var extraFields = form.querySelectorAll('[name^="properties"], [name="selling_plan"]');
      Array.prototype.forEach.call(extraFields, function (field) {
        if (!field.name || field.disabled) return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        if (field.type === 'file' && field.files && field.files.length) {
          Array.prototype.forEach.call(field.files, function (file) {
            formData.append(field.name, file);
          });
          return;
        }
        if (field.value !== '') formData.append(field.name, field.value);
      });
    }

    if (targetEl && targetEl.classList) {
      targetEl.classList.add('is-loading');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
    .then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, status: res.status, data: data };
      });
    })
    .then(function (result) {
      if (targetEl && targetEl.classList) {
        targetEl.classList.remove('is-loading');
      }
      if (result.ok) {
        if (typeof callback === 'function') {
          callback(result.data);
        } else if (typeof Shopify.onItemAdded === 'function') {
          Shopify.onItemAdded(result.data);
        }
      } else {
        // Show actual Shopify error
        var msg = (result.data && result.data.description)
          ? result.data.description
          : (result.data && result.data.message)
          ? result.data.message
          : (window.cartStrings && window.cartStrings.addProductOutQuantity2)
          ? window.cartStrings.addProductOutQuantity2
          : 'Could not add to cart';

        // Handle inventory limit specifically.
        if (inputEl && inputEl.getAttribute) {
          var maxValue = parseInt(inputEl.getAttribute('data-inventory-quantity'), 10);
          if (maxValue > 0) {
            msg = typeof getInputMessage === 'function' ? getInputMessage(maxValue) : msg;
            inputEl.value = maxValue;
          }
        }

        if (typeof showWarning === 'function') {
          showWarning(msg, 3000);
        }
      }
    })
    .catch(function (err) {
      console.error('CompuMe cart error:', err);
      if (targetEl && targetEl.classList) {
        targetEl.classList.remove('is-loading');
      }
      var msg = (window.cartStrings && window.cartStrings.addProductOutQuantity2)
        ? window.cartStrings.addProductOutQuantity2
        : 'Could not add to cart. Please try again.';
      if (typeof showWarning === 'function') showWarning(msg, 3000);
    });
  };

});

/* ─── STORAGE PAGE — BRAND FILTER STRIP ────────────────────────────────────────
 * Injects a horizontal brand shortcut row above the product grid
 * on /collections/storage only.
 * Each chip applies a metafield filter so results show only that brand.
 * ────────────────────────────────────────────────────────────────────────────── */
(function () {
  if (typeof window === 'undefined') return;
  if (window.location.pathname !== '/collections/storage') return;

  var brands = [
    { label: 'All Brands', value: '' },
    { label: 'Samsung', value: 'Samsung' },
    { label: 'Western Digital', value: 'Western Digital' },
    { label: 'Seagate', value: 'Seagate' },
    { label: 'Kingston', value: 'Kingston' },
    { label: 'Silicon Power', value: 'Silicon Power' },
    { label: 'Crucial', value: 'Crucial' },
    { label: 'Lexar', value: 'Lexar' },
    { label: 'SanDisk', value: 'SanDisk' }
  ];

  function getActiveBrand() {
    var params = new URLSearchParams(window.location.search);
    return params.get('filter.p.m.compume.brand_name') || '';
  }

  function buildStrip() {
    var existing = document.getElementById('cm-storage-brands');
    if (existing) return;

    var activeBrand = getActiveBrand();

    var strip = document.createElement('div');
    strip.id = 'cm-storage-brands';
    strip.setAttribute('aria-label', 'Filter storage by brand');

    brands.forEach(function (b) {
      var a = document.createElement('a');
      var params = new URLSearchParams(window.location.search);
      params.delete('filter.p.m.compume.brand_name');
      params.delete('page');
      if (b.value) {
        params.set('filter.p.m.compume.brand_name', b.value);
      }
      var qs = params.toString();
      a.href = window.location.pathname + (qs ? '?' + qs : '');
      a.className = 'cm-sb-chip' + (activeBrand === b.value ? ' active' : '');
      a.textContent = b.label;
      strip.appendChild(a);
    });

    var grid = document.getElementById('CollectionProductGrid') ||
               document.querySelector('.collection');
    if (grid && grid.parentNode) {
      grid.parentNode.insertBefore(strip, grid);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildStrip);
  } else {
    buildStrip();
  }

  var observer = new MutationObserver(function () {
    if (!document.getElementById('cm-storage-brands')) buildStrip();
  });
  var gridEl = document.getElementById('CollectionProductGrid');
  if (gridEl && gridEl.parentNode) {
    observer.observe(gridEl.parentNode, { childList: true, subtree: false });
  }
})();
